{
    "addToCart": "Zum Warenkorb hinzufügen",
    "yes": "Ja",
    "no": "Nein",
    "login": "Einloggen",
    "cancel": "Abbrechen",
    "close": "Schliessen",
    "couponApplied": "Rabatt angewendet!",
    "unappliedCoupon": {
        "title": "Rabatt nicht angewendet",
        "description": "Scanne das passende Produkt, um den Rabatt zu erhalten."
    },
    "done": "Fertig",
    "welcome": "Willkommen",
    "welcomeScan": "Bezahle bequem und einfach via Self-Checkout",
    "total": "Total",
    "toPayment": "Zur Bezahlung",
    "back": "Zurück",
    "quantityNeeded": "Benötigte Menge",
    "confirmCart": "Wurden alle Artikel gescannt?",
    "interactWithTerminal": "Benutze das Zahlungsterminal, um den Kauf abzuschliessen",
    "endTitle": "Kauf erfolgreich!",
    "endSubtitle": "Du bist startklar. Wir freuen uns, dass du bei uns einkaufst!",
    "feedbackQuestion": "Wie war deine Erfahrung?",
    "endThanksForFeedback": "Danke für dein Feedback!",
    "endSeeYouLater": "Wir freuen uns auf deinen nächsten Besuch.",
    "getReceipt": "Beleg",
    "scanQRCode": "Scanne diesen QR-Code, um deinen digitalen Beleg herunterzuladen.",
    "printReceipt": "Beleg drucken",
    "receiptPrinted": "✔ Beleg gedruckt",
    "finalizeSession": "Abschliessen",
    "productNotFound": "Huch! Wir können diesen Artikel nicht finden",
    "okDismiss": "OK",
    "somethingWentWrong": "Etwas ist schiefgelaufen",
    "pleaseTryAgain": "Bitte nochmal versuchen",
    "pleaseWait": "Einen Moment...",
    "tryAgain": "Nochmal versuchen",
    "reload": "Neu laden",
    "stillThere": "Bist du noch da?",
    "continue": "Weiter",
    "startOver": "Neu anfangen",
    "scan": "Scanne einen Artikel, um ihn zu deinem Warenkorb hinzuzufügen",
    "wantToStartOver": "Bist du sicher, dass du neu starten möchtest?",
    "wantToStartOverDescription": "Alle gescannten Artikel werden aus deinem Warenkorb gelöscht.",
    "changeLanguage": "Sprache wechseln",
    "ageVerification": "Ausweis scannen, um Alter zu überprüfen",
    "scanId": "Um dieses Produkt zu kaufen, musst du deinen <strong>Ausweis einscannen</strong>, um dein Alter zu verifizieren.",
    "holdIdSteady": "<strong>Hinweis:</strong> Bitte halte deinen Ausweis ruhig in Richtung des Scanners",
    "sorryCantSell": "Tut uns leid, wir können dir dieses Produkt nicht verkaufen",
    "sorryCantSellDescription": "Wir können dieses Produkt nur an Personen über 18 Jahre verkaufen.",
    "invalidId": "Wir konnten diesen Ausweis nicht lesen. Bitte nochmal versuchen",
    "verificationSuccessful": "Verifizierung erfolgreich!",
    "startShopping": "Einkauf starten",
    "startShoppingKitchen": "Essen bestellen",
    "wantToDeleteLineItem": "Bist du sicher, dass du den Artikel löschen möchten?",
    "wantToDeleteLineItemDescription": "Das Produkt wird aus deinem Warenkorb entfernt.",
    "promotionsDontWork": "<strong>Hinweis:</strong> Produkte mit Promotionen funktionieren noch nicht mit dieser Kasse",
    "addToBasket": "Hinzufügen",
    "promo": "Aktion",
    "product": "Produkt",
    "productAdded": "Produkt hinzugefügt!",
    "product_other": "Produkte",
    "operatorModeDialog": {
        "title": "Brauchst du Hilfe?",
        "description": "Für weitere Aktionen bitte den Mitarbeiter-Code scannen."
    },
    "orderList": {
        "collapseDetails": "Einklappen",
        "expandDetails": "Ausklappen",
        "details": "Details",
        "title": "Bestellungen"
    },
    "checkoutError": {
        "default": "Oops, deine Zahlung ist fehlgeschlagen. Bitte nochmal versuchen",
        "AbortedByUser": "Die Zahlung wurde storniert, bitte versuche es erneut.",
        "PaymentDeviceNotFound": "Für diesen SCO konnte kein Payment Terminal gefunden werden.",
        "CouponNotFound": {
            "title": "Coupon nicht gefunden",
            "description": "Dieser Coupon kann nicht angewendet werden, da er nicht gefunden werden kann."
        },
        "CouponNotApplicable": {
            "title": "Coupon nicht anwendbar",
            "description": "Dieser Coupon passt zu keinem Artikel in deinem Warenkorb. Bitte scanne zuerst das Produkt."
        },
        "CouponExpired": {
            "title": "Coupon abgelaufen",
            "description": "Dieser Coupon kann nicht angewendet werden, da er abgelaufen ist."
        },
        "CouponAlreadyRedeemed": {
            "title": "Coupon bereits verwendet",
            "description": "Dieser Coupon kann nicht angewendet werden, da er bereits verwendet wurde."
        },
        "CouponRedemptionFailed": {
            "title": "Coupon-Einlösung fehlgeschlagen",
            "description": "Der Coupon konnte nicht eingelöst werden. Bitte versuche es erneut."
        }
    },
    "operatorMode": "Operator-Modus",
    "operator": {
        "configuration": {
            "title": "Konfiguration",
            "individualConfig": {
                "title": "SCO-Konfiguration"
            },
            "storeConfig": {
                "title": "Verkaufstelle-Konfiguration"
            },
            "status": {
                "label": "SCO aktiviert",
                "confirmDisable": "Bist du sicher, dass du den SCO deaktivieren möchtest?",
                "confirmEnable": "Bist du sicher, dass du den SCO aktivieren möchtest?"
            },
            "cartCheck": {
                "label": "Warenkorbprüfung aktiviert",
                "confirmDisable": "Willst du die Warenkorbprüfung wirklich deaktivieren?",
                "confirmEnable": "Willst du die Warenkorbprüfung wirklich aktivieren?"
            }
        },
        "hardware": {
            "title": "Hardware",
            "lamp": "Lampe",
            "printer": "Drucker",
            "scanner": "Scanner",
            "red": "Rot",
            "green": "Grün",
            "print": "Testbeleg drucken",
            "clear": "Zurücksetzen",
            "blink": "Blinken",
            "paymentTerminal": "Zahlungsterminal",
            "login": "Einloggen",
            "paymentDeviceConfig": {
                "currentIp": "Aktuelle IP-Adresse",
                "ipLabel": "Neue IP-Adresse",
                "invalidIp": "Ungültige IP-Adresse",
                "setIp": "IP setzen",
                "probe": "Prüfen",
                "probeSucceeded": "Prüfung erfolgreich",
                "probeFailed": "Prüfung fehlgeschlagen",
                "loginSucceeded": "Anmeldung erfolgreich",
                "loginFailed": "Anmeldung fehlgeschlagen: {{reason}}",
                "status": "Status",
                "statuses": {
                    "ready": "Bereit",
                    "requiresLogin": "Anmeldung erforderlich",
                    "unreachable": "Nicht erreichbar"
                },
                "ipUpdated": "IP-Adresse aktualisiert",
                "ipUpdateFailed": "IP-Adresse konnte nicht aktualisiert werden: {{reason}}",
                "alterIp": "IP ändern",
                "dialogTitle": "Zahlungsterminal-IP",
                "close": "Schließen"
            }
        },
        "systemInformation": {
            "title": "Systeminformationen",
            "deviceId": "Geräte-ID",
            "cashRegisterId": "SAP Kasse-ID",
            "paymentDeviceId": "Zahlungsgerät-ID",
            "paymentDeviceIp": "Zahlungsgerät-IP",
            "runningVersion": "Laufende Version",
            "storeId": "Filial-ID",
            "productPresetIds": "Produktvoreinstellungs-IDs",
            "kitchenMenuId": "The Kitchen menuü-ID",
            "tenant": "Mieter"
        }
    },
    "order": "Bestellung",
    "order_other": "Bestellungen",
    "insight": "Insight",
    "insight_other": "Insights",
    "insightGrouping": {
        "groupBy": "Gruppieren",
        "scoId": "Self-checkout",
        "category": "Kategorie"
    },
    "productCategory": {
        "label": "Kategorie",
        "ABF": "Abfall",
        "BTRM": "Betriebsmaterial",
        "BUCH": "Bücher",
        "CBAU": "Compatible unit",
        "CH00": "CH Vertragsverwaltung",
        "CONT": "KANBAN-Behälter",
        "COUP": "Coupon",
        "DIEN": "Dienstleistung n.best.gef",
        "DLU1": "Dienstleistung best.gef.",
        "EPA": "Ausstattungspaket",
        "ERSA": "Ersatzteile",
        "FERT": "Fertigerzeugnis",
        "FGTR": "Getränke",
        "FHMI": "Fertigungshilfsmittel",
        "FOOD": "Food (excl. Frische)",
        "FRIP": "Frischprodukte",
        "HALB": "Halbfabrikat",
        "HAWA": "Handelsware",
        "HERS": "Herstellerteil",
        "HIBE": "Hilfs-/Betriebsstoff",
        "IBAU": "Instandhaltungs-Baugruppe",
        "INTR": "Intramaterial",
        "KMAT": "Konfigurierbares Material",
        "LEER": "Leergut",
        "LEIH": "Leihgut-Packmittel",
        "LGUT": "Leergut (zu VOLL)",
        "MODE": "Mode (saisonal)",
        "MPO": "Materialplanungsobjekt",
        "NLAG": "Nichtlagermaterial",
        "NOF1": "Non Food",
        "PIPE": "Pipeline-Material",
        "PLAN": "Handelsware (geplant)",
        "PRES": "Presse",
        "PROC": "Prozess-Material",
        "PROD": "Produktgruppe",
        "ROH": "Rohstoff",
        "TBAK": "Tabak",
        "UNBW": "Unbewertetes Material",
        "VBFO": "Verbrauchsmat. FOOD",
        "VERP": "Verpackung",
        "VKHM": "Verkaufshilfsmittel",
        "VOLL": "Vollgut",
        "WERB": "Werbemittel",
        "WERT": "Wertmaterial",
        "WETT": "Wettbewerberprodukt",
        "ZAUF": "Aufwandsartikel",
        "ZAUS": "Presse - Ausgabe",
        "ZFRG": "Franchising Gebühren",
        "ZGIF": "Ravita Giftcards",
        "ZILV": "AGS: Int. Leistungsverr.",
        "ZITP": "AGS: IT-Projekte",
        "ZLEI": "Leihgut Kiosk AG",
        "ZLOG": "Dienstleistungen Logistik",
        "ZMFE": "AGS: Management fee",
        "ZOBJ": "Presse - Objekt",
        "ZRAV": "Ravita PinCodes",
        "ZSER": "AGS: Serviceartikel"
    },
    "totalRevenue": "Gesamtumsatz",
    "needReceipt": "<strong>Brauchst du einen Beleg?</strong> Du findest ihn unter Einstellungen > Kaufhistorie",
    "orderNumber": "Bestellung",
    "takeReceipt": "<strong>Wichtig</strong>: Gib diesen Bestellschein beim Küchenpersonal ab, wenn deine Bestellung bereit ist.",
    "kitchen": "Kitchen",
    "theKitchen": "The Kitchen",
    "kitchenMenu": {
        "backToCart": "Zum Warenkorb",
        "productUnavailable": "Nicht verfügbar",
        "allergens": "Allergene",
        "nutritionalInformation": "Zutaten und Herkunft",
        "productInformation": "Produktinformationen",
        "upsellingTitle": "Noch was dazu?"
    },
    "availableAtAvec": "Verfügbar in diesem avec",
    "kitchenDescription": "Drücke den The Kitchen Button, um das Menü zu öffnen",
    "unknown": "Unbekannt",
    "dateRangePicker": {
        "from": "Von",
        "to": "Bis"
    },
    "outOfOrder": {
        "title": "Ups! Ein Problem ist aufgetreten",
        "subtitle": "Die Selbstbedienungskasse ist vorübergehend ausser Betrieb, aber wir arbeiten mit Hochdruck daran, das Problem zu beheben."
    },
    "cartCheckTriggered": "Dein Warenkorb wurde zufällig für eine manuelle Kontrolle ausgewählt. Bitte warte, bis ein Mitarbeiter zu dir kommt.",
    "cartError": {
        "Unknown": {
            "title": "Ups! Ein Problem ist aufgetreten. Bitte nochmal versuchen"
        },
        "CouponAlreadyRedeemed": {
            "title": "Coupon schon eingelöst",
            "body": "Der Coupon wurde bereits eingelöst. Bitte überprüfe den Coupon und versuche es erneut."
        },
        "ServiceNotSellable": {
            "title": "Bitte nutze eine bediente Kasse",
            "body": "Dieser Artikel kann nur an einer bedienten Kasse gekauft werden."
        },
        "CouponNotApplicable": {
            "title": "Coupon nicht anwendbar",
            "body": "Dieser Coupon passt zu keinem Artikel in deinem Warenkorb. Bitte scanne zuerst das Produkt."
        }
    }
}
